module.exports = __webpack_public_path__ + "static/media/stairs.5a9800fb.svg";